import React, { useRef } from "react";
import { connect } from "react-redux"

import GovernorateInfo from "./GovernorateInfo/GovernorateInfo";
import Stats from "./Stats/Stats";
import nextMove from "../../assets/images/next-move-en_80.gif";
import nextMoveStatic from "../../assets/images/next-move-en.gif";
import {
  closeTooltip,
  nextTurn,
  openContentPopup,
  openTooltip
} from "../../store/actions";
import { CHAT_TYPE } from "../../lib/enums";
import HelpIcon from "../Common/HelpIcon";
import { isTouchScreen } from "../../lib/elementUtilities";

const GameHeader = (props) => {
  const pointsOfPowerRef = useRef();
  return (
    <div className="game-header">
      <div className="container-fluid">
        <div className="game-header-content">
          <GovernorateInfo/>
          <Stats/>

          {/* Notifications */}
          <div className="notifications hidden-xs">
            <div
              className={"notification"}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-around",
                color: "#fff"
              }}
              ref={pointsOfPowerRef}
              onMouseEnter={() => !isTouchScreen() && props.openTooltip({
                name: "PointsOfPower",
                static: true,
                title: "Points of power",
                content: "Points of power allow you to unlock higher levels of buildings. You can earn points of power in wars or by training Economist general.",
                elementRef: pointsOfPowerRef
              })}
              onMouseOver={() => !isTouchScreen() && props.openTooltip({
                name: "PointsOfPower",
                static: true,
                title: "Points of power",
                content: "Points of power allow you to unlock higher levels of buildings. You can earn points of power in wars or by training Economist general.",
                elementRef: pointsOfPowerRef
              })}
              onClick={() => isTouchScreen() && props.openTooltip({
                name: "PointsOfPower",
                static: true,
                title: "Points of power",
                content: "Points of power allow you to unlock higher levels of buildings. You can earn points of power in wars or by training Economist general.",
                elementRef: pointsOfPowerRef
              })}
              onMouseLeave={!isTouchScreen() && props.closeTooltip}
            >
              <i className="icon icon-xmd icon-pozemky"/>
              <span style={{
                display: "flex",
                flexFlow: "column",
                textAlign: "right",
                whiteSpace: "nowrap"
              }}
              >
                <span>{props.powerPoints || 0}</span>
              </span>
            </div>
            {/* <a */}
            {/*  className={`notification flex-centered ${props.alliance ? "" : "disabled"}`} */}
            {/*  onClick={() => props.alliance && props.openContentPopupDispatch({ */}
            {/*    name: "AllianceBoard", */}
            {/*    title: "Alliance board", */}
            {/*    icon: "statistiky" */}
            {/*  })} */}
            {/* > */}
            {/*  <i className="icon icon-xmd icon-statistiky"/> */}
            {/* </a> */}

            <a
              className={`notification flex-centered ${props.newPosts.chat ? "minus" : ""}`}
              onClick={() => props.openContentPopupDispatch({
                name: "Chat",
                title: `${props.alliance ? "Alliance" : "World"} Chat`,
                icon: "politika",
                type: props.alliance ? CHAT_TYPE.Alliance : CHAT_TYPE.Public
              })}
            >
              <i className="icon icon-xmd icon-politika"/>
            </a>
            <a
              className={`notification flex-centered ${props.newPosts.mail ? "minus" : ""}`}
              onClick={() => props.openContentPopupDispatch({
                name: "Mail",
                title: "Mail",
                icon: "posta",
                h1classes: "border-bottom"
              })}
            >
              <i className="icon icon-xmd icon-posta"/>
            </a>
            <div
              className="notification round hidden-xs hidden-sm"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="dark-grey" style={{
                display: "flex",
                marginLeft: "auto",
                marginRight: "auto",
              }}>TURN
                <strong className="value" style={{ display: "flex", alignSelf: "center" }}>
                  {props.turn}/{props.maxTurns}
                </strong>
              </div>

              {props.turnBank > 0
                ? <div style={{
                  paddingLeft: "10px",
                  display: "flex",
                  flexFlow: "column",
                  marginRight: "auto"
                }}>
                  <div className="dark-grey" style={{ lineHeight: "initial" }}>BANK
                    <strong className="text-bigger value" style={{ fontSize: "16px", paddingLeft: "3px" }}>
                      {50 - props.turnBank}/50
                    </strong>
                  </div>
                  <div style={{ lineHeight: "initial" }}>
                    <small>(usable {props.turnBankExpiration} days)</small>
                  </div>
                </div> : <></>
              }
            </div>
          </div>

          {/* Next turn for mobile */}
          <div className="round-notification visible-xs-block visible-sm-block">
            <span className="dark-grey">Turn</span>
            <strong className="value" style={{ lineHeight: 1 }}>
              {props.turn}/{props.maxTurns}
              {props.turnBank > 0
              && <>&nbsp;<HelpIcon
                title={"Turn bank"}
                content={`<p class="text-info">${100 - props.turnBank}/100</p>
                          <small>(usable ${props.turnBankExpiration} days)</small>`}
                iconClasses={["white", "middle"]}
              /></>}
            </strong>
          </div>

          <a
            onClick={(props.maxTurns > props.turn || props.turnBank) > 0 && props.nextTurn}
            className={`next-move ${props.maxTurns > props.turn || props.turnBank > 0 ? "" : "disabled"}`}
          >
            <img
              src={props.maxTurns > props.turn || props.turnBank > 0 ? nextMove : nextMoveStatic}
              width={94}
              height={94}
              alt="Next turn"
            />
          </a>
        </div>
      </div>
      <div className="color-overlay"/>
    </div>
  )
};

const mapStateToProps = state => ({
  powerPoints: state.governorate.resources["power-points"],
  alliance: state.governorate.alliance,
  turn: state.governorate.turn,
  maxTurns: state.governorate.maxTurns,
  turnBank: state.governorate.turnBank,
  turnBankExpiration: state.governorate.turnBankExpiration,
  newPosts: state.governorate.newPosts
});

const mapDispatchToProps = dispatch => ({
  openContentPopupDispatch: contentPopupOptions => dispatch(openContentPopup(contentPopupOptions)),
  openTooltip: tooltipOptions => dispatch(openTooltip(tooltipOptions)),
  closeTooltip: () => dispatch(closeTooltip()),
  nextTurn: () => dispatch(nextTurn())
})

export default connect(mapStateToProps, mapDispatchToProps)(GameHeader);
